import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DateTime, Duration } from 'luxon';

import * as Styled from './styles';

const calculateTimeLeft = endDate => {
    const dateToDateTime = DateTime.fromMillis(Number(endDate), {
        zone: 'utc'
    });
    const now = DateTime.now();
    return dateToDateTime.diff(now, ['days', 'hours', 'minutes', 'seconds']);
};

const formatDuration = (millis, key) => {
    const formattedTimeUnit = Duration.fromMillis(millis)
        .shiftTo('days', 'hours', 'minutes', 'seconds', 'milliseconds')
        .toObject()[key];
    if (formattedTimeUnit < 0) {
        return '00';
    }
    if (formattedTimeUnit < 10) {
        return formattedTimeUnit.toString().padStart(2, '0');
    }
    return formattedTimeUnit.toString();
};

const getDateDaySuffix = day => {
    if (day === '1' || day === '21' || day === '31') {
        return 'st';
    }
    if (day === '2' || day === '22') {
        return 'nd';
    }
    if (day === '3' || day === '23') {
        return 'rd';
    }
    return 'th';
};

const formatDateHeader = date => {
    const [weekday, day, month, hour, minute, meridiem] = DateTime.fromMillis(
        Number(date)
    )
        .toFormat('cccc d LLLL h mm a')
        .split(' ');

    const daySuffix = getDateDaySuffix(day);

    const dateStr = `${weekday} ${day}${daySuffix} ${month}`;
    const timeStr = `${hour}:${minute}${meridiem.toLocaleLowerCase()}`;

    return `${dateStr} ${timeStr}`;
};

export const CountdownTimer = ({ date, name }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(date));
    const dateHeaderStr = formatDateHeader(date);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft(date));
        }, 1000);

        return () => clearInterval(interval);
    }, [timeLeft]);

    return (
        <div>
            <Styled.CountdownWrapper>
                <Styled.DateTimeHeader>{dateHeaderStr}</Styled.DateTimeHeader>
                <Styled.Title>{name} RACE</Styled.Title>
                <Styled.TimeWrapper>
                    <Styled.TimeUnitWrapper>
                        <Styled.TimeUnit>
                            {formatDuration(timeLeft, 'days')}
                        </Styled.TimeUnit>
                        <Styled.TimeUnitDescription>
                            days
                        </Styled.TimeUnitDescription>
                    </Styled.TimeUnitWrapper>
                    <Styled.TimeUnitWrapper>
                        <Styled.TimeUnit>
                            {formatDuration(timeLeft, 'hours')}
                        </Styled.TimeUnit>
                        <Styled.TimeUnitDescription>
                            hours
                        </Styled.TimeUnitDescription>
                    </Styled.TimeUnitWrapper>
                    <Styled.TimeUnitWrapper>
                        <Styled.TimeUnit>
                            {formatDuration(timeLeft, 'minutes')}
                        </Styled.TimeUnit>
                        <Styled.TimeUnitDescription>
                            mins
                        </Styled.TimeUnitDescription>
                    </Styled.TimeUnitWrapper>
                    <Styled.TimeUnitWrapper>
                        <Styled.TimeUnit>
                            {formatDuration(timeLeft, 'seconds')}
                        </Styled.TimeUnit>
                        <Styled.TimeUnitDescription>
                            secs
                        </Styled.TimeUnitDescription>
                    </Styled.TimeUnitWrapper>
                </Styled.TimeWrapper>
            </Styled.CountdownWrapper>
        </div>
    );
};

CountdownTimer.defaultProps = {
    date: DateTime.now(),
    name: ''
};

CountdownTimer.propTypes = {
    date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
};

export default CountdownTimer;
